<template>
  <div id="reportList" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <!-- 报备编码 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.bbbh') }}：</span>
          <div class="contentCopy">
            <el-input v-model="form.activityCode" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'activityCode')"
            />
          </div>
        </el-col>
        <!-- 活动名称 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.hdmc') }}：</span>
          <div class="contentCopy">
            <el-input v-model="form.activityName" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'activityName')"
            />
          </div>
        </el-col>
        <!-- 申请人 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('newApp.BasicInfo.Applicant') }}：</span>
          <div class="contentCopy">
            <el-input v-model="form.applyUserNameOrId" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'applyUserNameOrId')"
            />
          </div>
        </el-col>
        <!-- 审批状态 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('eventList.AppStatus') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.approvalStatus" clearable :placeholder="$t('general.ps')" @change="searchBtn">
              <el-option v-for="item in approvalStatusList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 对应销售 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="labelCopy">{{ $t('newApp.BasicInfo.cs') }}：</span>
          <div class="contentCopy">
            <el-input v-model="form.salerNameOrId" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'salerNameOrId')"
            />
          </div>
        </el-col>
        <!-- 申请部门 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="labelCopy">{{ $t('eventList.AppDepa') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.applyUserDeptNameOrCode" filterable remote clearable reserve-keyword
                       :placeholder="$t('general.peak')" :remote-method="getApplyDeptList" :loading="applyLoading"
            >
              <el-option v-for="item in applyDeptList" :key="item.userId" :label="item.deptName"
                         :value="item.deptCode"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 费用归属部门 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="labelCopy">{{ $t('newApp.Attribute.cad') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.expenseDeptNameOrCode" filterable remote clearable reserve-keyword
                       :placeholder="$t('general.peak')" :remote-method="getCostDeptList" :loading="applyLoading"
            >
              <el-option v-for="item in costDeptList" :key="item.userId" :label="item.deptName"
                         :value="item.deptCode"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 费用类型 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="labelCopy">{{ $t('newApp.Attribute.toe') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.expenseTypeCode" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in expenseTypeList" :key="item.expenseTypeCode" :label="item.expenseTypeName"
                         :value="item.expenseTypeCode"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 营销形式 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.yxfs') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.marketingForm" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in marketingFormsList" :key="item.val" :label="item.label"
                         :value="item.val"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 活动分类 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.coa') }}：</div>
          <div class="contentCopy">
            <el-select
              v-model="form.activityClassification"
              clearable
              :placeholder="$t('general.ps')"
              @change="searchBtn"
            >
              <el-option v-for="item in activityClassificationList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldKey" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <!-- 重置 -->
          <el-button plain @click="onreset">{{ $t('btn.Reset') }}</el-button>
          <!-- 搜索 -->
          <el-button type="primary" @click="searchBtn">{{ $t('btn.Search') }}</el-button>
        </div>
      </el-row>
      <!-- 高级搜索按钮 -->
      <div class="advancedSearchBtn">
        <span :class="searchOpenFlag ? 'open' : ''" @click="searchOpenFlag = !searchOpenFlag">
          <span>{{ searchOpenFlag ? $t('btn.CollspseS') : $t('btn.AdvancedS') }}</span>
          <i class="iconfont icon-rili4-icon" />
        </span>
      </div>
    </div>
    <!-- bi智能分析平台 -->
    <div class="common_btnBar">
      <el-button type="primary" @click="biJump">{{ $t('eventList.BIFind') }}</el-button>
      <el-button type="primary" @click="exportExcel">{{ $t('btn.Export') }}</el-button>
    </div>
    <commonTable ref="reportListTable" />
    <!-- 审批流程 -->
    <approvalProcessDialog :is-report="true" :activity-code="currentActivityCode"
                           :approval-dialog-visible="approvalDialogVisible" @dialogCloseHandle="approvalCloseHandle"
    />
    <!-- 召回修改 -->
    <quickProceDialog :title="quickProceTitle" :quick-proce-dialog-visible="quickProceDialogVisible"
                      :activity-code="currentActivityCode" @dialogCloseHandle="quickProceCloseHandle"
                      use-page="industryReportList" :approve-status-code="approveStatusCode"
    />
    <!-- 活动评估 -->
    <assessmentDialog :activity-code="currentActivityCode" :assessment-dialog-visible="assessmentDialogVisible"
                      @dialogCloseHandle="assessmentDialogClose" @handlerSuccess="assessmentSuccess"
    />

    <activityLevelDialog ref="activityLevelDialog" :activity-code="currentActivityCode"
                         :activity-level-dialog-visible="activityLevelDialogVisible"
                         @dialogCloseHandle="activityLevelDialogClose"
                         @handlerSuccess="activityLevelSuccess"
    />

    <productPromotionLeadingDialog ref="productPromotionLeadingDialog" :activity-code="currentActivityCode"
                                   :product-promotion-leading-dialog-visible="productPromotionLeadingDialogVisible"
                                   @dialogCloseHandle="productPromotionLeadingDialogClose"
                                   @handlerSuccess="productPromotionLeadingSuccess"
    />
    <!-- 活动工具包 配置弹窗 -->

    <el-dialog :title="$t('industryReport.hdxx.hdgjb')" :visible.sync="dialogVisible" width="600px" class="activityDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-suffix="：" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="$t('industryReport.hdxx.gjblj')" prop="activityToolkit">
          <el-input v-model="ruleForm.activityToolkit" :placeholder="$t('industryReport.hdxxtsy.gjblj')" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">
          {{ $t('btn.Cancel') }}
        </el-button>
        <el-button @click="toolkitSave('ruleForm')" type="primary">
          {{ $t('btn.OK') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import approvalProcessDialog from './component/activityQuery/approvalProcessDialog';
import quickProceDialog from './component/activityQuery/quickProceDialog';
import assessmentDialog from './component/reportList/assessmentDialog';
import activityLevelDialog from './component/reportList/activityLevelDialog';
import productPromotionLeadingDialog from './component/reportList/productPromotionLeadingDialog';
import { activityQuery } from './service';
import { newApplicationFormApi } from '../newApplicationForm/service';
import { arrayQuery } from '../../utils/utils';
import Big from 'big.js';
export default {
  name: 'IndustryReportList',
  components: {
    commonTable,
    approvalProcessDialog,
    quickProceDialog,
    activityLevelDialog,
    assessmentDialog,
    productPromotionLeadingDialog

  },
  data () {
    return {
      // 营销活动表单列表
      marketingFormsList: [
        {
          label: this.$t('industryReport.hybblb.cxtj.schd'),
          val: '1'
        },
        {
          label: this.$t('industryReport.hybblb.cxtj.szyx'),
          val: '2'
        }
      ],

      // 规则表单
      ruleForm: {
        activityToolkit: ''
      },

      // 表单验证规则
      rules: {
        activityToolkit: [
          { required: true, message: this.$t('industryReport.hdxxtsy.gjblj'), trigger: 'blur' }
        ]
      },

      // 搜索面板显示状态
      searchOpenFlag: false,

      // 审批弹窗显示状态
      approvalDialogVisible: false,

      // 评估弹窗显示状态
      assessmentDialogVisible: false,

      // 活动等级弹窗显示状态
      activityLevelDialogVisible: false,

      // 产品推广领导审批弹窗显示状态
      productPromotionLeadingDialogVisible: false,

      // 通用弹窗显示状态
      dialogVisible: false,

      // 表单数据
      form: {
        activityStatus: 0,
        marketingForm: ''
      },

      // 临时表单数据
      tempForm: {
        activityStatus: 0
      },

      // 活动类型列表
      activityTypeList: [],

      // 申请部门列表
      applyDeptList: [],

      // 费用部门列表
      costDeptList: [],

      // 表格数据
      tableData: [],

      // 费用类型列表
      expenseTypeList: [],
      // 物料状态列表
      materialStatusList: [
        {
          label: this.$t('eventList.Configured'),
          val: '1'
        },
        {
          label: this.$t('eventList.NotCon'),
          val: '0'
        }
      ],

      // 当前活动编码
      currentActivityCode: '',

      // // 申请筛选条件
      // applyKey: 'all',
      // // 费用筛选条件
      // expenseKey: 'all',

      // 申请加载状态
      applyLoading: false,

      // 是否是品牌推广
      isBrandPromotion: false,

      // 快速流程弹窗显示状态
      quickProceDialogVisible: false,

      // 快速流程弹窗标题
      quickProceTitle: '',

      // 审批状态列表
      approvalStatusList: [],

      // 活动分类列表
      activityClassificationList: [],

      // 活动等级列表
      activityLevelList: [],
      // 当前语言
      lang: localStorage.getItem('lang') || 'zh-CN',
      approveStatusCode: null
    };
  },
  methods: {
    // 活动工具包 配置弹窗
    popUpontrol (row) {
      // 设置表单数据
      this.ruleForm = {
        // 设置活动工具包字段，如果row.activityToolkit存在则使用其值，否则设为空字符串
        activityToolkit: row.activityToolkit || '',
        // 设置扩展ID字段，直接使用row.expandId的值
        expandId: new Big(row.expandId),
        activityCode: row.activityCode,
        activityClassificationCode: row.activityClassificationCode
      };

      // 显示对话框
      this.dialogVisible = true;
    },
    // 活动工具包 配置弹窗 保存
    toolkitSave (formName) {
      // 验证表单
      this.$refs[formName].validate((valid) => {
        // 如果表单验证通过
        if (valid) {
          // 调用API进行工具包修改
          newApplicationFormApi.toolKitModification(this.ruleForm).then(res => {
            // 如果API返回状态码为200
            if (res.status === '200') {
              // 显示成功消息
              this.$message({
                message: this.$t('industryReport.hdxxtsy.hjbxgcg'),
                type: 'success'
              });
              // 关闭对话框
              this.dialogVisible = false;
              // 重新搜索
              this.searchBtn();
            }
          });
        }
      });
    },

    assessmentSuccess () {
      // 关闭评估对话框
      this.assessmentDialogVisible = false;
      // 执行搜索按钮点击事件
      this.searchBtn();
    },
    activityLevelSuccess () {
      this.$refs.activityLevelDialog.openDailg(false);
      this.searchBtn();
    },

     productPromotionLeadingSuccess () {
      this.$refs.productPromotionLeadingDialog.openDailg(false);
      this.searchBtn();
    },

    assessmentHandler (row) {
      this.currentActivityCode = row.activityCode;
      this.assessmentDialogVisible = true;
    },
     activityLevelHandler (row) {
      this.currentActivityCode = row.activityCode;
      this.$refs.activityLevelDialog.openDailg(true, row.activityLevel);
    },

    productPromotionLeadingHandler (row) {
      this.currentActivityCode = row.activityCode;
      this.$refs.productPromotionLeadingDialog.openDailg(true, row.productPromotionLeading);
    },

    assessmentDialogClose () {
      this.assessmentDialogVisible = false;
    },
    activityLevelDialogClose () {
      this.$refs.activityLevelDialog.openDailg(false);
    },
    productPromotionLeadingDialogClose () {
      this.$refs.productPromotionLeadingDialog.openDailg(false);
    },

    biJump () {
      window.open('http://ruijiebi.ruijie.com.cn/webroot/decision?rjl=oa');
    },
    exportExcel () {
      // 复制当前搜索条件作为导出条件，与列表查询保持一致
      const params = JSON.parse(JSON.stringify(this.form));
      params.reportType = '2';
      const loading = this.$loading({
        lock: true,
        text: this.$t('general.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      activityQuery.exportIndustryReportList(params).then(res => {
        loading.close();
        try {
          const arrayBuffer = res.data;
          const contentDisposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
          let fileName = '行业报备列表.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i);
            if (fileNameMatch) {
              fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
            }
          }
          const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          this.$message.success(this.$t('general.ExportSuccess'));
        } catch (e) {
          this.$message.error(this.$t('general.ExportFailure'));
        }
      }).catch(() => {
        loading.close();
        this.$message.error(this.$t('general.ExportFailure'));
      });
    },
    quickProcessingBtn (row, title) {
      this.quickProceTitle = title;
      this.currentActivityCode = row.activityCode;
      this.approveStatusCode = row.approveStatusCode;
      this.quickProceDialogVisible = true;
    },
    quickProceCloseHandle () {
      this.quickProceDialogVisible = false;
    },
    inputBoxFilter (val, key) {
      let numVal = val.replace(/^\s+|\s+$/g, '');
      this.$set(this.form, key, numVal);
    },
    // 搜索申请部门的选中事件
    applyChange () {

    },
    approvalStateBtn (row) {
      // 设置当前活动编码
          this.currentActivityCode = row.activityCode;
      // 显示审批对话框
          this.approvalDialogVisible = true;
  },
    approvalCloseHandle () {
      this.approvalDialogVisible = false;
    },
    onreset () {
      this.form = {
        activityStatus: 0,
        marketingForm: ''
      };
      this.searchBtn();
    },
    // 搜索事件
    searchBtn () {
      this.tempForm = JSON.parse(JSON.stringify(this.form));
      this.tempForm.reportType = '2';
      this.$refs.reportListTable.pageData.pageNum = 1;
      this.$refs.reportListTable.getTableData({ url: '/report/industryReportPage', params: this.tempForm });
    },
    detailsJump (row) {
      // 查看报备详情 跳转路由 把报备编码传过去
      // 获取当前用户ID
      // let { userId } = this.$store.state.userInfo.sysUser;

      // 以下是报备状态码的字段定义
      // fieldKey 100
      // fieldValue 报备审批中
      // fieldKey 101
      // fieldValue 报备审批完成
      // fieldKey 102
      // fieldValue 报备驳回
      // fieldValue 报备召回
      // fieldKey 104
      // fieldValue 报备撤销

      // 如果报备状态码为101且当前用户为申请用户
      // 目标难活动不支持转申请跟取消报备 - 审批完成正常进入详情不需要跳转新建页面操作
      this.$router.push({
        path: '/industryReportDetails',
        query: {
          activityCode: row.activityCode,
          metaActive: '/industryReportList'
        }
      });
      // const isReportComplete = row.activityClassificationCode !== 'AC_01';
      // if (row.approveStatusCode === 101 && row.applyUserId === userId && isReportComplete) {
      //   const path = row.marketingForm === 1 ? '/activityTransferApplication' : '/quickTransferApplication';
      //   // 跳转到报备审批完成页面
      //   this.$router.push({
      //     path,
      //     query: {
      //       activityCode: row.activityCode,
      //       metaActive: '/industryReportList'
      //     }
      //   });
      // } else {
      //   // 否则跳转到报备详情页面
      //   this.$router.push({
      //     path: '/industryReportDetails',
      //     query: {
      //       activityCode: row.activityCode,
      //       metaActive: '/industryReportList'
      //     }
      //   });
      // }
    },
    loadTable () {
      let tableRow = new TableRow();
      // 报备编码
      tableRow.push(
        new TableColumns()
          ._width('160')
          ._title(this.$t('industryReport.hybblb.cxtj.bbbh'))
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              const routeData = this.$router.resolve({
                path: '/industryReportDetails',
                query: {
                  activityCode: row.activityCode,
                  metaActive: '/industryReportList'
                }
              });
              return (
                <div>
                  <a class="btnText" href={routeData.href} onClick={(e) => { e.preventDefault(); this.detailsJump(row); }}>{row.activityCode}</a>
                </div>
              );
            }
          })
      );
      // 活动名称/营销主题

      tableRow.push(
        new TableColumns()
          ._width('18%')
          ._title(this.$t('industryReport.hybblb.cxtj.hdmc'))
          ._data('activityName')
      );
      // 营销形式
      tableRow.push(
        new TableColumns()
          ._width('14%')
          ._title(this.$t('industryReport.hybblb.cxtj.yxfs'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span>{row.marketingForm === 1 ? this.$t('industryReport.hybblb.cxtj.schd') : this.$t('industryReport.hybblb.cxtj.szyx')}</span>
                </div>
              );
            }
          })
      );
      // 面向全国发布

      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('industryReport.hybblb.cxtj.ffzq'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span>{row.isNationalRelease === 1 ? this.$t('btn.Yes') : this.$t('btn.No')}</span>
                </div>
              );
            }
          })
      );
      // 申请人

      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('industryReport.hybblb.cxtj.sqr'))
          ._data('applyUserName')
      );
      // 对应销售

      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('industryReport.hybblb.cxtj.dyxs'))
          ._data('salerName')
      );
      // 部门

      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('industryReport.hybblb.cxtj.bm'))
          ._data('salerDeptName')
      );
      // 报备时间

      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('industryReport.hybblb.cxtj.bbsj'))
          ._data('applyTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row.applyTime.replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{date}</span>
              );
            }
          })
      );
      // 活动工具包

      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('industryReport.hybblb.cxtj.hdgjb'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" onClick={() => { this.popUpontrol(row); }}>{
                    row.activityToolkit ? this.$t('industryReport.hybblb.list.ypz') : this.$t('industryReport.hybblb.list.wpz')
                    }</span>
                </div>
              );
            }
          })
      );
      // 营销费用

      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('industryReport.hybblb.cxtj.yxfy'))
          ._data('totalCost')
      );
      // 审批状态

      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.AppStatus'))
          ._align('left')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let text = row.approveStatus;
              if (this.form.approvalStatus) {
                text = arrayQuery(this.form.approvalStatus, this.approvalStatusList, 'fieldKey').fieldValue;
              }
              return (
                <div>
                  <el-button type="text" onClick={() => { this.approvalStateBtn(row); }}>{text}</el-button>
                </div>
              );
            }
          })
      );
      // 操作
      tableRow.push(
        new TableColumns()
          ._width('210')
          ._title(this.$t('general.Operation'))
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let userInfo = this.$store.state.userInfo;
              // 召回修改：当费用归属只有一条的时候才可以召回    召回后该活动会保存在草稿里
              // 活动评估：当前登陆人为品牌推广部的才可以进行活动评价
              return (
                <div>
                  <el-button type="text" onClick={() => { this.quickProcessingBtn(row, this.$t('btn.Revoke')); }}>{this.$t('btn.Revoke')}</el-button>
                  <el-button type="text" onClick={() => { this.quickProcessingBtn(row, this.$t('btn.RecallC')); }}>{this.$t('btn.RecallC')}</el-button>
                  {
                    userInfo.sysUser.deptCode.indexOf('000013') === 0 ? (
                      <el-button type="text" onClick={() => { this.assessmentHandler(row); }}>{this.$t('btn.ActivityE')}</el-button>
                    ) : null
                  }
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.reportListTable.setColumn(column, {
        resizable: true
      });
      this.$refs.reportListTable.loadTable({ url: '/report/industryReportPage', listKey: 'list', params: { activityStatus: 0, reportType: '2' } });
    },
    getActivityType () {
      let params = [
        'activity_type',
        'activity_classification'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.activityTypeList = res.data.activity_type;
          this.activityClassificationList = res.data.activity_classification.filter(item => {
            return item.fieldKey !== 'AC_02' && item.fieldKey !== 'AC_03';
          }) || [];
        }
      });
    },
    getApplyDeptList (applyKey) {
      if (applyKey && applyKey.indexOf(' ') === 0) {
        this.applyDeptList = [];
        return;
      }
      applyKey = applyKey || 'all';
      let params = {
        type: 'APPLAY',
        key: applyKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.applyDeptList = res.data;
        }
      });
    },
    getCostDeptList (expenseKey) {
      if (expenseKey && expenseKey.indexOf(' ') === 0) {
        this.costDeptList = [];
        return;
      }
      expenseKey = expenseKey || 'all';
      let params = {
        type: 'EXPENSE',
        key: expenseKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.costDeptList = res.data;
        }
      });
    },
    getExpenseTypeList () {
      activityQuery.getExpenseTypeList().then(res => {
        if (res.status === '200') {
          this.expenseTypeList = res.data;
        }
      });
    },
    getExamineStatusList () {
      let params = [
        'report_approval_status'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.approvalStatusList = res.data.report_approval_status;
        }
      });
    },
    getActivityLevelList () {
      let params = [
              'activity_level'
            ];
            newApplicationFormApi.getActivityList(params).then(res => {
              if (res.status === '200') {
                this.activityLevelList = res.data.activity_level;
              }
            });
    }
  },
  activated () {
    this.tempForm.reportType = '2';
    this.$refs.reportListTable.getTableData({ url: '/activity/market_activity_list', params: this.tempForm });
  },
  mounted () {
    this.isBrandPromotion = this.$store.state.userInfo.belongToBrandPromotionDept;
    this.loadTable();
    this.getActivityType();
    this.getApplyDeptList();
    this.getCostDeptList();
    this.getExpenseTypeList();
    this.getExamineStatusList();
    this.getActivityLevelList();
  }
};
</script>

<style scoped>

</style>
